React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'

class OrgInviteRestrictionsContentsComponent extends React.Component
  @displayName: 'OrgInviteRestrictionsContentsComponent'

  render: t.renderable ->
    { isAdmin, hasBC, restrictions } = @props

    t.div ->
      t.div '.setting-item-detail', ->
        t.div '.markeddown', ->
          if restrictions.length
            t.p ->
              t.format 'only-people-with-these-email-domains-can-join-this-organization'
            t.ul ->
              for restriction in restrictions
                t.li ->
                  t.strong ->
                    t.text restriction
          else
            t.p ->
              t.format 'anyone-with-any-email-domain-can-be-added-to-this-organization'

      if hasBC && !isAdmin
        t.p '.helper.u-float-left', ->
          t.format 'you-need-to-be-an-admin-to-change-this-setting'

module.exports = OrgInviteRestrictionsContentsComponent



// WEBPACK FOOTER //
// ./app/scripts/views/organization/org-invite-restrictions-component.coffee